module.exports =
  base: '/internal/employee/'
  detail: '/internal/employee/:employeeId'
  track: '/internal/employee/:employeeId/track'
  userTrack: '/internal/employee/user/track'
  barcode: '/internal/employee/barcode/:barcode'
  numberTrack: '/internal/employee/number/:number/track'
  shift:
    base: '/internal/employee/shift'
    edit: '/internal/employee/shift/:shiftId/edit'
    delete: '/internal/employee/shift/:shiftId/delete'
    report: '/internal/employee/shift/:facility/report'
    breaks:
      edit: '/internal/employee/shift/:shiftId/breaks/edit'
    offtime:
      edit: '/internal/employee/shift/:shiftId/offtime/edit'
    start: '/internal/employee/:employeeId/start'
    end: '/internal/employee/:employeeId/end'
    break: '/internal/employee/:employeeId/break'
    return: '/internal/employee/:employeeId/return'
    latest: '/internal/employee/:employeeId/latest'
  fingerprint:
    enroll: '/internal/employee/fingerprint/number/:number/enroll'
    verify: '/internal/employee/fingerprint/number/:number/verify'
  employeeShift:
    query: '/internal/employee/employeeShift/query'
    detail: '/internal/employee/employeeShift/:employeeShiftId'
  employee:
    bulk: '/internal/employee/employee/bulk'
    bulkByNumber: '/internal/employee/employee/bulkByNumber'
    query: '/internal/employee/employee/query'
  employeeLog:
    query: '/internal/employee/employeeLog/query'
    detail: '/internal/employee/employeeLog/:employeeLogId'
    bulkInsert: '/internal/employee/employeeLog/bulkInsert'
  health:
    base: '/internal/employee/__health'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/employee.coffee